<template>
  <div class="show_all_content_wrapper">
    <main>
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>
            {{
              $t("PLACEHOLDERS.Client_Subscriptions", {
                team: name,
              })
            }}
          </h5>
          <button
            v-if="!filterFormIsActive"
            class="filter_toggler"
            @click.stop="filterFormIsActive = !filterFormIsActive"
          >
            <i class="fal fa-search"></i>
          </button>
        </div>
      </div>
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.categorical_subscription") }}</h5>
        </div>
      </div>
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeaders"
        :items="categorySubscriptions"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>

        <template v-slot:[`item.id`]="{ index }">
          <div class="table_image_wrapper">
            {{ index + 1 }}
          </div>
        </template>
        <template v-slot:[`item.game_category`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.category">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{ item.category.name }}
            </p>
          </div>
        </template>
        <template v-slot:[`item.package_value`]="{ item }">
          <div class="table_image_wrapper">
            <h6 class="text-danger" v-if="!item.category">
              {{ $t("TABLES.noData") }}
            </h6>
            <p v-else>
              {{ item.category.subscription_price }}
            </p>
          </div>
        </template>

        <template v-slot:[`item.name`]="{ item }">
          <span class="text-danger" v-if="!item.name">
            {{ $t("TABLES.noData") }}
          </span>
          <span v-else> {{ item.name }} </span>
        </template>

        <template v-slot:[`item.is_active`]="{ item }">
          <span class="text-success text-h5" v-if="item.is_active">
            <i class="far fa-check"></i>
          </span>
          <span class="text-danger text-h5" v-else>
            <i class="far fa-times"></i>
          </span>
        </template>
        <template v-slot:[`item.members`]="{ item }">
          <h6 class="text-danger" v-if="!item.members?.length">
            {{ $t("TABLES.noData") }}
            <!-- {{ item.teams }} -->
          </h6>

          <div v-else>
            <v-chip
              class="m-1"
              color="blue-grey darken-3"
              text-color="white"
              margin="2"
              small
              v-for="(role, index) in item.members"
              :key="'k' + index"
            >
              {{ role.name }}
            </v-chip>
          </div>
        </template>
      </v-data-table>
      <div class="table_title_wrapper">
        <div class="title_text_wrapper">
          <h5>{{ $t("PLACEHOLDERS.general_subscription") }}</h5>
        </div>
      </div>
      <v-data-table
        class="thumb"
        :loading="loading"
        :loading-text="$t('TABLES.loadingData')"
        :search="searchValue"
        :headers="tableHeadersPackages"
        :items="packageSubscriptions"
        item-class="ltr"
        :items-per-page="paginations.items_per_page"
        hide-default-footer
      >
        <template v-slot:no-data>
          {{ $t("TABLES.noData") }}
        </template>
        <template v-slot:[`item.id`]="{ index }">
          <div class="table_image_wrapper">
            {{ index + 1 }}
          </div>
        </template>
   

        <template v-slot:[`item.price`]="{ item }">
          <span class="text-danger" v-if="!item.package?.price">
            {{ $t("TABLES.noData") }}
          </span>
          <span v-else> {{ item.package?.price }} </span>
        </template>
        <template v-slot:[`item.games_count`]="{ item }">
          <span class="text-danger" v-if="!item.games_count">
            {{ $t("TABLES.noData") }}
          </span>
          <span v-else> {{ item.games_count }} </span>
        </template>
        <!-- <template v-slot:[`item.games_used`]="{ item }">
          <span class="text-danger" v-if="!item.used_games_count">
            {{ $t("TABLES.noData") }}
          </span>
          <span v-else> {{ item.used_games_count }} </span>
        </template> -->
        <template v-slot:[`item.members`]="{ item }">
          <h6 class="text-danger" v-if="!item.members?.length">
            {{ $t("TABLES.noData") }}
            <!-- {{ item.teams }} -->
          </h6>

          <div v-else>
            <v-chip
              class="m-1"
              color="blue-grey darken-3"
              text-color="white"
              margin="2"
              small
              v-for="(role, index) in item.members"
              :key="'k' + index"
            >
              {{ role.name }}
            </v-chip>
          </div>
        </template>
      </v-data-table>
      <!--  =========== End:: Data Table =========== -->
    </main>
    <!-- End:: Main Section -->

    <!-- Start:: Pagination -->
    <template>

    </template>
    <!-- End:: Pagination -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AllAdmins",

  computed: {
    ...mapGetters({
      getAppLocale: "AppLangModule/getAppLocale",
      allRoles: "ApiGetsModule/allRoles",
    }),

    activeStatuses() {
      return [
        {
          id: 1,
          name: this.$t("STATUS.active"),
          value: 1,
        },
        {
          id: 2,
          name: this.$t("STATUS.notActive"),
          value: 0,
        },
      ];
    },
  },

  data() {
    return {
      packageSubscriptions: [],
      categorySubscriptions: [],

      // Start:: Loading Data
      loading: false,
      isWaitingRequest: false,
      deactivateLoading: false,
      // End:: Loading Data

      // Start:: Filter Data
      filterFormIsActive: false,
      filterOptions: {
        name: null,
        phone: null,
        email: null,
        role: null,
        isActive: null,
      },
      // End:: Filter Data

      // Start:: Table Data
      searchValue: "",
      tableHeaders: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          width: "80",
          sortable: false,
        },

        {
          text: this.$t("PLACEHOLDERS.package_value"),
          value: "package_value",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.startDate"),
          value: "start_date",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("PLACEHOLDERS.plays_count"),
          value: "games_count",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.game_category"),
          value: "game_category",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.games_used"),
          value: "used_games_count",
          align: "center",
          sortable: false,
        },
      ],
      tableHeadersPackages: [
        {
          text: this.$t("TABLES.Admins.serialNumber"),
          value: "id",
          align: "center",
          width: "80",
          sortable: false,
        },

        {
          text: this.$t("PLACEHOLDERS.package_name"),
          value: "name",
          align: "center",
          sortable: false,
        },

        {
          text: this.$t("PLACEHOLDERS.package_price"),
          value: "price",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.number_of_available_usages"),
          value: "games_count",
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("PLACEHOLDERS.games_used"),
          value: "used_games_count",
          align: "center",
          sortable: false,
        },
      ],
      tableRows: [],
      // End:: Table Data
      name: null,
      // Start:: Dialogs Control Data
      dialogImage: false,
      selectedItemImage: null,
      dialogDeactivate: false,
      itemToChangeActivationStatus: null,
      deactivateReason: null,
      dialogDelete: false,

      itemToDelete: null,
      // End:: Dialogs Control Data

      // Start:: Pagination Data
      paginations: {
        current_page: 1,
        last_page: 1,
        items_per_page: 6,
      },
      // End:: Pagination Data

      // Start:: Page Permissions
      permissions: null,
      // Start:: Page Permissions
    };
  },

  watch: {
    ["$route.query.page"]() {
      this.paginations.current_page = +this.$route.query.page;
      this.setTableRows();
    },
  },

  methods: {
    async setTableRows() {
      this.loading = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `clients/${this.$route.params.id}`,

          params: {
            page: this.paginations.current_page,
            name: this.filterOptions.name,
            email: this.filterOptions.email,
            mobile: this.filterOptions.phone,
            // role: this.filterOptions.role?.id,
            isActive: this.filterOptions.isActive?.value,
          },
        });
        this.categorySubscriptions = res.data.data.data.categorySubscriptions;
        this.packageSubscriptions = res.data.data.data.packageSubscriptions;

        this.name = res.data.data.data.name;
        this.paginations.last_page = res.data.data.meta.last_page;
        this.paginations.items_per_page = res.data.data.meta.per_page;
      } catch (error) {
        console.log(error.response.data.message);
      } finally {
        this.loading = false;
      }
    },
    // End:: Set Table Rows

    showTeam(item) {
      this.$router.push({ path: `/admins/show/${item.id}/teams` });
    },
    // ===== End:: End

    // Start:: Vuex Actions
    ...mapActions({
      getRoles: "ApiGetsModule/getRoles",
    }),
    // End:: Vuex Actions
  },

  async created() {
    // Start:: Fire Methods
    window.addEventListener("click", () => {
      this.filterFormIsActive = false;
    });
    if (this.$route.query.page) {
      this.paginations.current_page = +this.$route.query.page;
    }
    this.setTableRows();
    await this.getRoles();
    // End:: Fire Methods
  },
};
</script>
